import _ from 'lodash';
import Helpers from '../../../../common/helpers';

export const validate = (values, props) => {
  let fields = props && props.selectedPaymentMethodType && props.selectedPaymentMethodType.fields_config;

  if (fields && fields.length > 0) {
    fields = _.map(fields, field => {
      return _.assign(field, {
        name: field.id,
      });
    });
  }

  return Helpers.validateForm(values, fields);
};



// WEBPACK FOOTER //
// ./src/app/main/payment-methods/validators/payment-methods-validators.js